import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import GuideContent from "@/components/guest/GuideContent";

export default function GuidePage() {
  const { id, idx } = useParams();
  const [addon, setAddon] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get(`/addons/${id}`)
      .then((r) => { setAddon(r.data); setStatus("ok"); })
      .catch(() => setStatus("error"));
  }, [id]);

  const page = addon?.guide_pages?.[Number(idx)];

  if (status === "loading") {
    return <div className="min-h-screen flex items-center justify-center bg-brand-bg text-brand-forest/60">Loading…</div>;
  }
  if (status === "error" || !page) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg text-center px-6" data-testid="guide-page-empty">
        <div>
          <BookOpen size={40} className="mx-auto text-brand-terracotta mb-4" />
          <p className="font-display text-2xl text-brand-forest">Guide not found</p>
          <p className="text-brand-forest/60 mt-2">This guide isn't available. Please check with your host.</p>
        </div>
      </div>
    );
  }

  const hasHub = (addon.guide_pages?.length || 0) + (addon.info_content?.trim() ? 1 : 0) + ((addon.map_spots || []).length ? 1 : 0) >= 2;

  return (
    <div className="min-h-screen bg-brand-bg" data-testid="guide-page">
      <div className="bg-brand-forest text-white">
        <div className="max-w-3xl mx-auto px-6 py-12">
          {hasHub && (
            <Link to={`/basket/${id}`} data-testid="guide-back" className="inline-flex items-center gap-1.5 text-white/70 hover:text-white text-sm mb-5">
              <ArrowLeft size={16} /> All {addon.title} guides
            </Link>
          )}
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-testid="guide-title">{page.title}</h1>
          {page.subtitle && <p className="text-white/70 mt-3">{page.subtitle}</p>}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-10">
        <GuideContent text={page.content} />
        <p className="text-center text-xs text-brand-forest/40 pt-10">MyAZbnb.com</p>
      </div>
    </div>
  );
}
